export default {
  stat: () => import('./MicroStat.vue'),
  list: () => import('./MicroList.vue'),
  funnel: () => import('./MicroFunnel.vue'),
  strip: () => import('./MicroStrip.vue'),
};
